module.exports = __webpack_public_path__ + "static/media/Car-step-icon-fc.9c69fb68.svg";